import { EditorState, Plugin, Transaction } from 'prosemirror-state'
import { ReplaceAroundStep, ReplaceStep } from 'prosemirror-transform'

export const KeepMarks = new Plugin({
  appendTransaction: (transactions: Transaction[], oldState: EditorState, newState: EditorState) => {
    // NOTE: if we inserted/replaced or changed the node attrs of  something
    // that is not text and the marks changed, add the marks as stored marks
    // again.
    // Examples of this include pressing enter on a colored paragraph or on a
    // list item as well as indenting a list item
    if (
      ((oldState.selection.$from.marks().length && !newState.selection.$from.marks().length) || oldState.storedMarks) &&
      transactions.some((tr) =>
        tr.steps.find(
          (step) =>
            (step instanceof ReplaceStep || step instanceof ReplaceAroundStep) &&
            !step.slice.content.firstChild?.isText,
        ),
      )
    ) {
      // NOTE: if the user has set any stored marks, just carry these over, otherwise use the marks at the position before
      return newState.tr.setStoredMarks(oldState.storedMarks || oldState.selection.$from.marks())
    }
  },
})
